import { render, staticRenderFns } from "./StudentsHistory.vue?vue&type=template&id=faf5ba0e&"
import script from "./StudentsHistory.vue?vue&type=script&lang=js&"
export * from "./StudentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports